import axios from 'axios';
import * as types from '../../actions/actionTypes';
import * as agentinfo from '../../actions/agent-application-info-actions/agent-application-info-actions';
import * as constants from '../../../constants/constants';
import { history } from '../../history';
import { getToken } from '../aws/token';

const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';
let REQUEST_TYPE = 'application/json';
let sendEmailEndpoint = `${API_ENDPOINT}/v1/surety-bond/sendemail`;
let authHeader =
  'Authorization, Origin, X-Requested-With, Content-Type, Accept';
let methodsAllowed = 'OPTIONS,POST,GET';
let network = 'Network Error';
export const setAgentStatusToDisable = (email, authToken, success) => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token1,
      email: email,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
    dispatch(agentinfo.setAgentInfo(true));
    axios
      .post(
        `${API_ENDPOINT}/v1/surety-bond/customer/info/agent/disable`,
        '',
        config,
      )
      .then(response => {
        if (response.data) {
          success();
        } else {
          history.push('/accountDisabled');
        }
      })
      .catch(error => {
        handleError(error, dispatch, 'ERR:NCP-AG-DISBALE-DOWN');
      });
  };
};

export const getAgentPendingApplications = (authToken, onSuccess) => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      // 'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token1,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch({
      type: types.SET_REMOVE_INFO_ERROR,
    });
    dispatch({
      type: types.SET_REMOVE_ERROR,
    });
    dispatch(agentinfo.setAgentInfo(true));
    // setTimeout(() => {
    axios
      .post(
        `${API_ENDPOINT}/v1/surety-bond/customer/info/agent/all`,
        '',
        config,
      )
      .then(response => {
        dispatch(agentinfo.setAgentInfoSuccess(false, response.data));
        onSuccess();
      })
      .catch(error => {
        handleError(error, dispatch, ' ERR:NCP-SB-ALL-DOWN');
      });
    //  }, 9000);
  };
};

export const setAgentApplicationUpdates = (payload, authToken) => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      'Access-Control-Allow-Methods': methodsAllowed,
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token1,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
    dispatch(agentinfo.setAgentInfo(true));
    axios
      .put(
        `${API_ENDPOINT}/v1/surety-bond/customer/info/agent/update`,
        payload,
        config,
      )
      .then(response => {
        dispatch(agentinfo.setAgentInfoUpdate(false, response.data));
        history.push('/submitSuccess');
        return axios
          .all([
            axios.post(
              sendEmailEndpoint,
              {
                subject: constants.depAdminSubject(
                  response.data.district,
                  response.data.appStatus,
                ),
                templateName:
                  constants.DEPOSIT_ADMIN_EMAIL_STATUS_TEMPLATE_NAME,
                bondNumber: response.data.bondNumber,
                billAccount: response.data.billAccount,
                companyName: response.data.companyName,
                district: response.data.district,
                status: response.data.appStatus,
                emailAddress: constants.DepsoitAdminEmail,
              },
              {
                headers: {
                  'Content-Type': REQUEST_TYPE,
                  'Access-Control-Allow-Origin': '*',
                  'Access-Control-Allow-Headers': authHeader,
                  'Access-Control-Allow-Methods': methodsAllowed,
                  'Access-Control-Allow-Credentials': 'true',
                  Authorization: `Bearer ` + token1,
                },
                crossorigin: true,
              },
            ),
          ])
          .then(
            axios.spread((firstResponse, secondResponse) => {
              console.log(firstResponse.data, secondResponse.data);
            }),
          );
      })
      .catch(error => {
        console.log('in service', error.response);

        handleError(error, dispatch, 'ERR:NCP-UPDATE-DOWN');
      });
  };
};

export const deleteAgentApplication = (payload, authToken) => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      'Access-Control-Allow-Methods': methodsAllowed,
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token1,
      id: payload.id,
    },
  };
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
    dispatch(agentinfo.setAgentInfo(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/customer/info/delete`, '', config)
      .then(response => {
        dispatch(agentinfo.setAgentInfoDelete(false, payload, response.data));
        history.push('/home');
      })
      .catch(error => {
        console.log('in service', error);
        handleError(error, dispatch, 'ERR:NCP-DELETE-DOWN');
      });
  };
};

const checkFor503 = (error, dispatch, code) => {
  if (error.response.status === 409) {
    console.log(
      'Inside checkFor503, error.response.status is :',
      error.response.status,
    );
    dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-DB-DOWN'));
  } else if (error.response && error.response.data.fault !== undefined) {
    console.log(
      'Inside checkFor503, error.response && error.response.data.fault: ',
      error.response.data.fault,
    );
    dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-AG-SVS-APIGEE-DOWN'));
  } else {
    console.log('Inside checkFor503 final else', error);
    dispatch(agentinfo.setErrorPage(false, code));
  }
  history.push('/error');
};

const handleError = (error, dispatch, code) => {
  // console.log('HandleError ', error.response);
  if (
    error.status !== undefined &&
    (error.status >= 500 ||
      error.status >= 400 ||
      error.response.status === 503 ||
      error.response.status === 409)
  ) {
    checkFor503(error, dispatch, code);
  } else if (error.status === 401 || error === network) {
    console.log('Inside HandleError error.status 401 || network', error);
    localStorage.clear();
    dispatch(
      agentinfo.setAgentInfoError(false, 'Session timed out, Please sign in '),
    );
    history.push('/login');
  } else if (
    error.response !== undefined &&
    error.response.data !== undefined &&
    (error.response.data.status === 500 || error.response.data.status >= 400)
  ) {
    console.log('Inside HandleError error.response.data.status >= 400', error);
    dispatch(agentinfo.setErrorPage(false, code));
    history.push('/error');
  } else if (
    error.response !== undefined &&
    error.response.data !== undefined &&
    error.response.data.status === 500 &&
    error.response.data.messages !== undefined
  ) {
    console.log('Inside HandleError error.response.data.messages', error);
    history.push('/error');
    dispatch(
      agentinfo.setAgentInfoError(
        false,
        error.response.data.messages[0].message,
      ),
    );
  } else {
    console.log('Inside HandleError final else', error);
    dispatch(agentinfo.setAgentInfoError(false, error));
  }
};
